module.exports = __webpack_public_path__ + "img/RKTEDYFC.db609d69.png";